import styled from 'styled-components';
import { Radio } from 'antd';


export const ItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex-shrink: 0;

	min-height: 0;
	
	padding: 20px 20px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		padding: 10px 20px 0px 20px;
	}

	@media (max-height: ${(props) => props.theme.mediaQueryConstants.lowHeight}px) {
    padding-top: 10px;
	}

	@media (max-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {
    padding-top: 5px;
	}
`;

export const FontTitleContainer = styled(ItemContainer)`
	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		padding-bottom: unset;
	}
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;

  letter-spacing: 0.03em;

	margin-bottom: 25px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 10px;
	}

	@media (max-height: ${(props) => props.theme.mediaQueryConstants.lowHeight}px) {
    margin-bottom: 10px;
	}

	@media (max-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {
    margin-bottom: 5px;
	}
`;

export const Symbols = styled.div`
	display: flex;
	justify-content: space-between;
  align-items: center;
  
  padding-bottom: 10px;
`;

export const StyledRadioGroup = styled(Radio.Group)`
	.ant-radio:hover {
		border-color: ${({theme}) => theme.colors.fallow}; 
	}
	
	.ant-radio-checked .ant-radio-inner {
		border-color: ${({theme}) => theme.colors.fallow}; 
		
		:after {
			background-color: ${({theme}) => theme.colors.fallow}; 
		}
	}
	
	.ant-radio-wrapper {
		font-size: 15px;
		width: 100%;
		
		display: flex;
		flex-direction: row-reverse;
		justify-content: space-between;
		align-items: center;
		
		margin-bottom: 30px;
		
		span:last-child {
		  padding-left: unset;
		}

		& > span:last-child {
			width: 100%;
		}

		@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
			margin-bottom: 10px;
		}

		@media (max-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {
			margin-bottom: 5px;
		}
	}
`;


